import React from "react";
import { Modal, Card, Row, Col, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faStar } from "@fortawesome/free-solid-svg-icons";
import "./View_Share_Taxi_Rating_Model.css";

function View_Share_Taxi_Rating_Model({ show, onHide, rating, name }) {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>🚖 {name} Ratings </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          {rating?.map((d, index) => (
            <Col md={6} lg={4} key={index} className="mb-4">
              <Card className="rating-card shadow-sm h-100">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <Badge bg={d?.name === "Customer" ? "primary" : "success"}>
                      {d?.name}
                    </Badge>

                    <div className="rating-stars">
                      {[...Array(Number(d?.rating || 0))].map((_, i) => (
                        <FontAwesomeIcon
                          key={i}
                          icon={faStar}
                          className="text-warning me-1"
                        />
                      ))}
                    </div>
                  </div>

                  <div className="mb-2">
                    <FontAwesomeIcon
                      icon={faUser}
                      className="me-2 text-primary"
                    />
                    <strong>Rating For:</strong>{" "}
                    {d?.name === "Customer"
                      ? d?.User?.first_name
                      : d?.Driver?.first_name}
                  </div>

                  <div className="mb-3">
                    <FontAwesomeIcon
                      icon={faUser}
                      className="me-2 text-success"
                    />
                    <strong>Rating From:</strong>{" "}
                    {d?.name === "Customer"
                      ? d?.Driver?.first_name
                      : d?.User?.first_name}
                  </div>

                  <div className="mb-2">
                    <strong>Rating:</strong>{" "}
                    <Badge bg="warning" text="dark">
                      {d?.rating}/5
                    </Badge>
                  </div>

                  <div className="comment-box mt-3">
                    <strong>Review:</strong>
                    <p className="mb-0 mt-1 text-muted">
                      {d?.comment || "No Review provided"}
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {rating?.length === 0 && (
          <div className="text-center py-4">
            <h5>No Ratings Found</h5>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default View_Share_Taxi_Rating_Model;
